module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "bk-title"
  }, [_c('span', [_vm._v("Jasmine and the Jumping Pony")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('span', [_vm._v("Pony Tails, Book Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "authorname"
  }, [_c('span', [_vm._v("Bonnie Bryant")])]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('span', [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "images/fig_01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5c1d2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 57
// module chunks = 0